import { render, staticRenderFns } from "./ProductSizes.vue?vue&type=template&id=e625a896&scoped=true&"
import script from "./ProductSizes.vue?vue&type=script&lang=js&"
export * from "./ProductSizes.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizes.vue?vue&type=style&index=0&id=e625a896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e625a896",
  null
  
)

export default component.exports